import { createContext, useContext } from 'react';

export const AnalyticsContext = createContext();

export const useAnalytics = () => useContext(AnalyticsContext);
